import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';

var _convertPropToCssClas = convertPropToCssClassName('form-required-mark'),
    cssClassName = _convertPropToCssClas.cssClassName;

var RequiredMark = function RequiredMark(_ref) {
  var _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional;
  if (!required && !optional) return null;

  if (required) {
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(cssClassName)
    }, "\u25CF");
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(cssClassName, " optional-mark")
  }, "\u26AC");
};

export default RequiredMark;
//# sourceMappingURL=RequiredMark.js.map
